import styled from "styled-components";

import { StyledInputNumber } from "../styled";

const PaymentSplitContainer = styled.div`
  border-radius: 8px;
  border: 1px solid #d2d6db;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  padding: 16px 0;
  margin-top: 24px;
  margin-bottom: 24px;

  .payment-split-label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: #64636e;
    font-weight: 500;
  }

  .payment-split-label-bullet {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  .payment-split-label-bullet-first {
    background: #4f46e5;
  }

  .payment-split-label-bullet-second {
    background: #d0ccfe;
  }
`;

const StyledTitleContainer = styled.div`
  border-bottom: 1px solid #d2d6db;
  padding: 0 16px;
  i {
    color: #64636e;
    font-size: 14px;
  }
`;

interface IPaymentSplitSectionProps {
  firstCardAmount: number;
  secondCardAmount: number;
  totalPaymentAmount: number;
  onFirstCardAmountChange: (e: { value: number | null }) => void;
  onSecondCardAmountChange: (e: { value: number | null }) => void;
}

export function PaymentSplitSection({
  firstCardAmount,
  secondCardAmount,
  totalPaymentAmount,
  onFirstCardAmountChange,
  onSecondCardAmountChange,
}: IPaymentSplitSectionProps) {
  return (
    <PaymentSplitContainer>
      <StyledTitleContainer>
        <p
          className="font-medium text-gray-900 mb-3"
          style={{ fontSize: "16px", justifySelf: "flex-start" }}
        >
          Payment Split
        </p>
      </StyledTitleContainer>

      <div className="flex md:flex-row flex-column gap-3 px-3 pt-3 justify-content-center">
        <div className="flex flex-column gap-1 md:w-1/2 w-full">
          <span className="payment-split-label">
            <span className="payment-split-label-bullet payment-split-label-bullet-first" />
            First Card
          </span>
          <StyledInputNumber
            id="payment-split-first-card"
            value={firstCardAmount}
            mode="currency"
            currency="USD"
            locale="en-US"
            min={1}
            max={totalPaymentAmount - 1}
            onValueChange={onFirstCardAmountChange}
          />
        </div>
        <div className="flex flex-column gap-1 md:w-1/2 w-full">
          <span className="payment-split-label">
            <span className="payment-split-label-bullet payment-split-label-bullet-second" />
            Second Card
          </span>
          <StyledInputNumber
            id="payment-split-second-card"
            value={secondCardAmount}
            mode="currency"
            currency="USD"
            locale="en-US"
            min={1}
            max={totalPaymentAmount - 1}
            onValueChange={onSecondCardAmountChange}
          />
        </div>
      </div>
      <p className="text-sm text-gray-600 text-center font-normal mt-2">
        Enter an amount in either field - the other will auto-balance
      </p>
    </PaymentSplitContainer>
  );
}
